import {EntityManager, Repository} from "aurelia-orm";
import {Item} from "../entities/item";

export class DataServiceBase<T extends Item> {

    repository: Repository;

    constructor(entityType:string, private entityManager: EntityManager) {
        this.repository = entityManager.getRepository(entityType);
    }

    getChildren(id: number, entityStatusId:number) {
        return this.repository.find("children?parentId=" + id + "&entityStatusId=" + entityStatusId);
    }

    getDetails(id: number) {
        return this.repository.find("details?id=" + id);
    }

    search(searchText: string) {
        return this.repository.find("search?searchText=" + searchText);
    }

    listTrashed(): Promise<Array<T>> {
        return this.repository.find('list-trashed');
    }

    listArchived(): Promise<Array<T>> {
        return this.repository.find('list-archived');
    }

    getNew() : T {
        return this.repository.getNewEntity();
    }

    listActive() : Promise<Array<T>> {
        return this.repository.find("list-active");
    }
}